import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary } from '@cmd/ui-components';
import { useSelector } from 'react-redux';
import LandingPageHeader, { dateRangeSelector } from './components/LandingPageHeader/LandingPageHeader';
import SlideOut from './components/slide-out/SlideOut';
import LogiView from './logi/LogiView';
import './LandingPage.scss';
const LandingPage = () => {
    const dateRange = useSelector(dateRangeSelector);
    return (_jsxs("main", { id: "landing-page", children: [_jsx(LandingPageHeader, {}), dateRange && (_jsx(ErrorBoundary, { className: "landing-page-error-boundary", children: _jsx(LogiView, {}) })), _jsx(SlideOut, {})] }));
};
export default LandingPage;
